module.exports = __webpack_public_path__ + "324a5291a2f23cca3bfb0deaa2f0e002.svg";